module.exports = ""


//////////////////
// WEBPACK FOOTER
// ./src/app/app_manager/app_element/communication-room/communication-room.component.css
// module id = ./src/app/app_manager/app_element/communication-room/communication-room.component.css
// module chunks = main